/* Fritaire Deluxe landing — behaviour for templates/page.landing-v2.json
   Loaded from layout/theme.liquid only when template.suffix == 'landing-v2'. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* the hero film: lighter file on phones, chosen before the browser fetches */
  document.querySelectorAll('[data-dlx-video]').forEach(function (v) {
    var small = v.dataset.srcMobile;
    v.src = (small && matchMedia('(max-width: 749px)').matches) ? small : v.dataset.src;
  });

  /* reveal on scroll */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: .18, rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.dlx .rv').forEach(function (el) { io.observe(el); });

  /* The theme header hides and reappears as you scroll, so the product nav
     follows its live bottom edge instead of a fixed offset — it sits under the
     header when it is showing and rides up to the top when it is gone. */
  /* The theme header (.header-shell in sections/header.liquid) slides out of the
     way on scroll down and back on scroll up. The product nav follows its real
     bottom edge, so it sits under the header when shown and at the very top when
     the header has gone. */
  var shell = document.querySelector('.header-shell') || document.querySelector('.shopify-section-group-header-group');
  function headerBottom() {
    if (!shell) return 0;
    var r = shell.getBoundingClientRect();
    return Math.max(0, Math.round(r.bottom));
  }
  var navTick = false;
  function fitNav() {
    document.documentElement.style.setProperty('--dlx-hdr', headerBottom() + 'px');
  }
  function queueFitNav() {
    if (navTick) return;
    navTick = true;
    requestAnimationFrame(function () { fitNav(); navTick = false; });
  }
  fitNav();
  addEventListener('load', fitNav);
  addEventListener('resize', queueFitNav);
  addEventListener('scroll', queueFitNav, { passive: true });
  /* the header animates its slide, so keep following it while it moves */
  if (shell) shell.addEventListener('transitionend', fitNav);

  /* product sub-nav appears once the hero is behind you */
  var pnav = document.querySelector('[data-dlx-pnav]'), hero = document.querySelector('.dlx .hero');
  if (pnav && hero) {
    new IntersectionObserver(function (e) { pnav.classList.toggle('on', !e[0].isIntersecting); },
      { rootMargin: '-60% 0px 0px 0px' }).observe(hero);
  }

  /* the theme header sits above the hero, so one screen is svh minus that */
  var heroEl = document.querySelector('.dlx .hero');
  function fitHero() {
    if (!heroEl) return;
    document.documentElement.style.setProperty('--top-h', Math.round(heroEl.getBoundingClientRect().top + scrollY) + 'px');
  }
  addEventListener('load', fitHero); addEventListener('resize', fitHero);
  setTimeout(fitHero, 400); setTimeout(fitHero, 1200);

  /* the hero film drifts slightly as you scroll away from it */
  var heroVid = document.querySelector('[data-dlx-hero-video]');
  if (heroVid && !reduce) {
    var tick = false;
    addEventListener('scroll', function () {
      if (tick) return; tick = true;
      requestAnimationFrame(function () {
        heroVid.style.transform = 'translate3d(0,' + (Math.min(scrollY, innerHeight) * 0.08) + 'px,0)';
        tick = false;
      });
    }, { passive: true });
  }

  /* finishes: swatch switches photo, name and the variant the form will add */
  var fin = document.querySelector('[data-dlx-finishes]');
  if (fin) {
    var imgs = fin.querySelectorAll('[data-fin-img]'),
        name = fin.querySelector('[data-fin-name]'),
        cta = fin.querySelector('[data-fin-cta]'),
        input = fin.querySelector('[data-fin-variant]'),
        form = fin.querySelector('form');
    fin.querySelectorAll('[data-fin-swatch]').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = b.dataset.finSwatch;
        fin.querySelectorAll('[data-fin-swatch]').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        imgs.forEach(function (im) { im.classList.toggle('on', im.dataset.finImg === i); });
        if (name) name.textContent = b.dataset.name;
        if (input) input.value = b.dataset.variant;
        if (fin.dataset.tintOnSelect !== 'false' && b.dataset.tint) fin.style.backgroundColor = b.dataset.tint;
        if (cta) {
          var sold = b.dataset.available === 'false';
          var missing = !b.dataset.variant;
          cta.textContent = missing ? 'Coming soon'
            : sold ? 'Sold out'
            : (cta.dataset.label || 'Pre-order') + ' in ' + b.dataset.name;
          sold = sold || missing;
          cta.disabled = sold;
          if (form) form.classList.toggle('is-soldout', sold);
        }
      });
    });
  }

  /* units-left tickers (hero + finishes): one simulated countdown, not real
     inventory, mirrored into every [data-dlx-stock]. The ticker carrying
     data-start holds the settings. It drops at a jittered pace to a floor,
     drops once as soon as each ticker first comes into view, and the value is
     kept for the tab session so a refresh never jumps it back up, while a
     new visit starts fresh. */
  var stks = document.querySelectorAll('[data-dlx-stock]'),
      stkSrc = document.querySelector('[data-dlx-stock][data-start]');
  if (stkSrc) {
    var stkMin = +stkSrc.dataset.min || 0,
        stkEvery = (+stkSrc.dataset.every || 15) * 1000,
        stkCur = +stkSrc.dataset.start, stkTimer;
    try {
      var saved = parseInt(sessionStorage.getItem('dlx-units-left'), 10);
      if (saved < stkCur) stkCur = Math.max(saved, stkMin);
    } catch (e) {}
    var stkShow = function (flash) {
      stks.forEach(function (el) {
        var n = el.querySelector('b');
        n.textContent = stkCur;
        el.hidden = false;
        if (flash) { n.classList.remove('tick'); void n.offsetWidth; n.classList.add('tick'); }
      });
    };
    var stkLater = function () { stkTimer = setTimeout(stkTick, stkEvery * (0.6 + Math.random() * 0.8)); };
    var stkTick = function () {
      clearTimeout(stkTimer);
      if (stkCur <= stkMin) return;
      stkCur--;
      stkShow(true);
      try { sessionStorage.setItem('dlx-units-left', stkCur); } catch (e) {}
      stkLater();
    };
    stkShow(false);
    stkLater();
    var stkIo = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        stkIo.unobserve(e.target);
        setTimeout(stkTick, 700);
      });
    }, { threshold: .5 });
    stks.forEach(function (el) { stkIo.observe(el); });
  }

  /* clips play only while visible — a dozen autoplaying videos throttle themselves */
  var vidIo = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      else v.pause();
    });
  }, { threshold: .15 });
  document.querySelectorAll('.dlx video').forEach(function (v) { vidIo.observe(v); });

  /* count-up numbers */
  var numIo = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target, end = parseFloat(el.dataset.count), dec = +(el.dataset.dec || 0);
      numIo.unobserve(el);
      if (reduce || isNaN(end)) { return; }
      var t0 = performance.now(), dur = 1100;
      (function step(t) {
        var k = Math.min((t - t0) / dur, 1), e2 = 1 - Math.pow(1 - k, 3);
        el.textContent = (end * e2).toFixed(dec);
        if (k < 1) requestAnimationFrame(step);
      })(t0);
    });
  }, { threshold: .6 });
  document.querySelectorAll('.dlx [data-count]').forEach(function (el) { numIo.observe(el); });
})();
